import { useState, useCallback } from "react";
const PAGE_SIZE = 10;
const useListKeyboardNavigation = (items, onSelect) => {
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const onKeyDown = useCallback(
    (e) => {
      if (!items || items.length === 0) return;
      switch (e.key) {
        case "ArrowDown":
          e.preventDefault();
          setHighlightedIndex((prev) => (prev + 1) % items.length);
          break;
        case "ArrowUp":
          e.preventDefault();
          setHighlightedIndex((prev) => (prev - 1 + items.length) % items.length);
          break;
        case "PageDown":
          e.preventDefault();
          setHighlightedIndex((prev) => Math.min(prev + PAGE_SIZE, items.length - 1));
          break;
        case "PageUp":
          e.preventDefault();
          setHighlightedIndex((prev) => Math.max(prev - PAGE_SIZE, 0));
          break;
        case "Home":
          e.preventDefault();
          setHighlightedIndex(0);
          break;
        case "End":
          e.preventDefault();
          setHighlightedIndex(items.length - 1);
          break;
        case "Enter":
          e.preventDefault();
          if (highlightedIndex >= 0 && onSelect) {
            onSelect(items[highlightedIndex], highlightedIndex);
          }
          break;
        default:
          break;
      }
    },
    [highlightedIndex, items, onSelect]
  );
  return { highlightedIndex, setHighlightedIndex, onKeyDown };
};
export default useListKeyboardNavigation;
